import { useState } from "react";
import { X } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function DevisModal({ formule, onClose }) {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", wedding_date: "", formule: formule || "", message: ""
  });
  const [status, setStatus] = useState(null); // null | "loading" | "success" | "error"

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch(`${API}/api/devis`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (res.ok) setStatus("success");
      else setStatus("error");
    } catch {
      setStatus("error");
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 0",
    border: "none",
    borderBottom: "1px solid rgba(61,22,2,0.2)",
    backgroundColor: "transparent",
    fontSize: "14px",
    color: "#3D1602",
    fontFamily: "'Inter', sans-serif",
    outline: "none",
    transition: "border-color 0.3s ease",
  };

  const labelStyle = {
    fontSize: "10px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    color: "#6D5E56",
    fontFamily: "'Inter', sans-serif",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      data-testid="devis-modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      style={{
        position: "fixed", inset: 0, zIndex: 200,
        backgroundColor: "rgba(61,22,2,0.5)",
        backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        data-testid="devis-modal"
        style={{
          backgroundColor: "#F7F3EA",
          width: "100%",
          maxWidth: "560px",
          maxHeight: "90vh",
          overflowY: "auto",
          padding: "48px 40px",
          position: "relative",
        }}
      >
        {/* Close */}
        <button
          onClick={onClose}
          data-testid="devis-modal-close"
          style={{
            position: "absolute", top: "20px", right: "20px",
            background: "none", border: "none", cursor: "pointer",
            color: "#3D1602", padding: "4px",
          }}
        >
          <X size={20} strokeWidth={1.5} />
        </button>

        {/* Header */}
        <p style={{ fontSize: "10px", letterSpacing: "4px", textTransform: "uppercase", color: "rgba(61,22,2,0.4)", marginBottom: "8px" }}>
          Demande de devis
        </p>
        <h2 style={{
          fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
          fontSize: "26px", fontWeight: 300, color: "#3D1602",
          marginBottom: "8px",
        }}>
          {formule ? `Formule ${formule}` : "Votre devis personnalisé"}
        </h2>
        <p style={{ fontSize: "13px", color: "#6D5E56", fontWeight: 300, marginBottom: "36px", lineHeight: 1.7 }}>
          Décrivez votre projet. Je vous réponds sous 48h avec une proposition personnalisée.
        </p>

        {status === "success" ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "22px", color: "#3D1602", marginBottom: "16px" }}>
              Votre demande a bien été envoyée.
            </p>
            <p style={{ fontSize: "13px", color: "#6D5E56", fontWeight: 300, lineHeight: 1.8 }}>
              Je vous répondrai dans les 48h avec une proposition personnalisée.<br />
              À très vite,<br /><em>Laurine</em>
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <div>
              <label style={labelStyle}>Nom & Prénom *</label>
              <input name="name" value={form.name} onChange={handleChange} required style={inputStyle} placeholder="Marie & Thomas" />
            </div>
            <div>
              <label style={labelStyle}>Email *</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} required style={inputStyle} placeholder="votre@email.com" />
            </div>
            <div>
              <label style={labelStyle}>Téléphone</label>
              <input name="phone" value={form.phone} onChange={handleChange} style={inputStyle} placeholder="+33 6 00 00 00 00" />
            </div>
            <div>
              <label style={labelStyle}>Date de mariage envisagée</label>
              <input name="wedding_date" value={form.wedding_date} onChange={handleChange} style={inputStyle} placeholder="Juin 2026" />
            </div>
            <div>
              <label style={labelStyle}>Formule souhaitée</label>
              <select name="formule" value={form.formule} onChange={handleChange} style={{ ...inputStyle, cursor: "pointer" }}>
                <option value="">Je ne sais pas encore</option>
                <option value="SYMPHONIE">SYMPHONIE — Organisation complète</option>
                <option value="CADENCE">CADENCE — Organisation partielle</option>
                <option value="APOGÉE">APOGÉE — Coordination Jour J</option>
                <option value="PRÉLUDE">PRÉLUDE — Coaching mariés</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Votre message *</label>
              <textarea name="message" value={form.message} onChange={handleChange} required rows={4}
                style={{ ...inputStyle, resize: "vertical", paddingTop: "12px" }}
                placeholder="Parlez-moi de votre projet, vos envies, votre date..."
              />
            </div>

            {status === "error" && (
              <p style={{ fontSize: "12px", color: "#c0392b" }}>Une erreur est survenue. Veuillez réessayer ou nous contacter directement.</p>
            )}

            <button
              type="submit"
              disabled={status === "loading"}
              data-testid="devis-submit-btn"
              style={{
                backgroundColor: "#3D1602",
                color: "#F7F3EA",
                border: "none",
                padding: "16px 32px",
                fontSize: "11px",
                letterSpacing: "3px",
                textTransform: "uppercase",
                fontFamily: "'Inter', sans-serif",
                cursor: status === "loading" ? "wait" : "pointer",
                opacity: status === "loading" ? 0.7 : 1,
                transition: "opacity 0.3s ease",
                marginTop: "8px",
              }}
            >
              {status === "loading" ? "Envoi en cours..." : "Envoyer ma demande"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
